import { GraphQLClient } from 'graphql-hooks';
const client = new GraphQLClient({
  url: process.env.REACT_APP_DATO_URL || '',
  headers: {
    Authorization: `Bearer ${process.env.REACT_APP_DATO_TOKEN}`
  }
});

export default client;
